// Hero passives: one always-on trait per character. Numbers live here (the player-facing prose is built from
// them in client/heroInfo.ts); game.ts/skills.ts apply them at the
// exact point each one changes (damage(), heal ticks, resolveAttack...). `stat` documents what that hero's
// `HeroStats.passive` counter measures, so a balance run can read one number per hero.
import type { HeroKind } from './heroes.js';

export const PASSIVES = {
  rhino: { mult: 0.5, stat: 'metres of knockback/pull displacement prevented' },
  durer: { r: 4, reduce: 0.08, stat: 'damage prevented on allies (before shields)' },
  landsknecht: { arc: Math.PI / 3, share: 0.35, stat: 'hp removed by the extra cleave hit' },
  arquebusier: { still: 1, bonus: 1.5, stat: 'basic attacks started only thanks to the extra range' },
  astrologer: { reveal: 2, stat: 'seconds of reveal granted (new time only, overlaps not double-counted)' },
  salamander: { dps: 4, ticks: 3, interval: 0.5, stat: 'hp removed by the afterburn' },
  death: { below: 0.3, bonus: 0.12, stat: 'extra hp removed by the bonus' },
  ferryman: { slow: 0.15, slowFor: 1, stat: 'seconds of slow applied to heroes' },
  devil: { leech: 0.15, stat: 'hp healed' },
  plague: { below: 0.4, bonus: 0.2, stat: 'extra hp healed plus extra shield granted' },
  monk: { mult: 0.6, regen: 0.005, stat: 'seconds of stun/slow/charm/fear prevented' },
  grotesque: { dmg: 3, stat: 'hp removed by the thorns' },
  shadow: { revealFor: 1, stillFor: 2, stat: 'seconds of enemy reveal avoided (trap reveals ignored, Прорицание cut short)' },
  sin: { window: 10, bonus: 5, stat: 'extra team score from kills' },
  nightmare: { r: 6, fountain: 0.5, stat: 'hp of enemy healing denied' },
  birdcatcher: { sight: 6, stat: 'seconds enemy heroes stood in sight of his birds' },
  puppeteer: { shield: 0.2, life: 4, stat: 'shield granted when his golem was destroyed' },
  shewolf: { r: 6, reduce: 0.15, stat: 'damage prevented while her wolves were near' },
} as const satisfies Record<HeroKind, { stat: string; [k: string]: number | string }>;
